import React, { Fragment, memo, useContext, useEffect, useMemo, useRef, useState } from 'react'
import SideBarIcon from './SideBarIcon'
import { GetURLPath, IsListNotEmpty, toolTipAtrributes } from '@utils'
import { useTranslation } from 'react-i18next'
import DirectLink from './DirectLink'
import { CRRender } from '@comp/crRender'
import { PrivilegeContext } from '@context/PrivilegesContext'
import { generator } from '@/utils/NumbersUtils'


const SubLink = ({ screen, handleNavigate, subOpendedScreens, isMenuOpened }) => {

    const { t } = useTranslation()
    const floatRef = useRef(null)

    const { authorizedPages } = useContext(PrivilegeContext)
    const { name, icon, id, path, children: childrenList } = useMemo(() => screen, [screen])
    const [isChildActive, setIsChildActive] = useState(false)

    useEffect(() => {
        const curretOpened = GetURLPath()
        const isListChild = IsListNotEmpty(childrenList?.filter(subSc => subSc.path == curretOpened))

        setIsChildActive(isListChild || (subOpendedScreens == path))
    }, [path, subOpendedScreens])

    useEffect(() => {
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                floatRef.current.style.display = "none"
            }
        });
        return () => {
            document.removeEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    floatRef.current.style.display = "none"
                }
            });
        };
    }, [])

    const visiable = !!authorizedPages.find(p => id?.includes(p.id))?.id && IsListNotEmpty(childrenList)


    return (
        <CRRender isRender={visiable}>

            <div className='dropDownContainer pointer' activeclassname="active"  >
                <li className={`${isChildActive ? "active" : ""} menu`}
                    onClick={() => handleNavigate(1, name)}
                    {...toolTipAtrributes(t(name), null, isMenuOpened)} >
                    <SideBarIcon icon={icon} />
                    <span className={`Item-name ${isMenuOpened ? "" : "d-none"}`}>{t(name)}</span>
                </li>

                <CRRender isRender={subOpendedScreens == name}>
                    <div ref={floatRef} className={"floated pointer"}>
                        {childrenList?.mapWithKey((subScreen) =>
                            <Fragment key={subScreen.key} >
                                <DirectLink screen={{ ...subScreen, id: [subScreen.id] }} handleNavigate={handleNavigate} />
                            </Fragment>
                        )}
                    </div>
                </CRRender>
            </div>

        </CRRender>

    )
}

export default memo(SubLink)